import React from "react";

const handleSmoothScroll = (e) => {
    e.preventDefault();
    const targetId = 'industries-section';
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
        window.scrollTo({
            top: targetElement.offsetTop,
            behavior: 'smooth'
        });
    }
};

export default function Banner() {
    return (
        <section className="mx-auto max-w-6xl px-4 sm:px-6 flex flex-col items-center justify-center py-12 text-center bg-white">
            <h2 className="font-uber text-[28px] font-bold leading-[36px] sm:text-[32px] sm:leading-[40px] xl-custom:text-[36px] xl-custom:leading-[44px] mb-4">
                Playables
            </h2>
            <p className="text-current font-uber text-[16px] font-normal leading-[24px] max-w-xl mb-6">
                Driving large-scale brand engagement through innovative, performance-led experiences that connect users meaningfully with campaigns
            </p>
            <button
                onClick={handleSmoothScroll}
                className="mt-4 px-6 py-2 bg-black text-white rounded active:bg-gray-700 active:text-white text-[16px] font-uber font-medium"
            >
                Discover More
            </button>
            <div className="w-full mt-10">
                <img
                    src="/uploads/Assets/hero_page_bg.webp"
                    alt="Playables preview"
                    className="w-full max-w-3xl mx-auto object-contain"
                />
            </div>
        </section>
    )
}